// Constants for currency conversion
export const BYTE_TO_NAIRA_RATE = 10; // 1 byte = 10 naira

/**
 * Convert Naira amount to Bytes
 * @param {number} nairaAmount - Amount in Naira
 * @returns {number} Amount in Bytes
 */
export const nairaToBytes = (nairaAmount) => {
  return nairaAmount / BYTE_TO_NAIRA_RATE;
};

/**
 * Convert Bytes amount to Naira
 * @param {number} byteAmount - Amount in Bytes
 * @returns {number} Amount in Naira
 */
export const bytesToNaira = (byteAmount) => {
  return byteAmount * BYTE_TO_NAIRA_RATE;
};

/**
 * Format Bytes amount with symbol
 * @param {number} byteAmount - Amount in Bytes
 * @returns {string} Formatted Bytes amount with symbol
 */
export const formatBytes = (byteAmount) => {
  return `₿${byteAmount.toFixed(2)}`;
};

/**
 * Format Naira amount with symbol
 * @param {number} nairaAmount - Amount in Naira
 * @returns {string} Formatted Naira amount with symbol
 */
export const formatNaira = (nairaAmount) => {
  return `₦${nairaAmount.toFixed(2)}`;
};